<template>
  <HeadlessDialog :open class="relative z-50" @close="close">
    <div class="fixed inset-0 bg-black/30" aria-hidden="true"></div>

    <div class="fixed inset-0 w-screen">
      <div class="flex min-h-full items-center justify-center">
        <HeadlessDialogPanel
          class="w-full flex flex-col bg-bgr sm:w-[80vw] sm:max-w-2xl sm:mx-auto"
          :class="{
            'max-h-[100vh]': screen.isExtraSmall,
            'max-h-[80vh]': !screen.isExtraSmall && screen.isSmall,
          }"
        >
          <header
            class="sticky top-0 z-10 flex items-center justify-between border-b bg-bgr p-6"
          >
            <HeadlessDialogTitle as="h3" class="text-xl font-medium">
              {{ $t(`${trPrefixCommon}filters`) }}
            </HeadlessDialogTitle>

            <button
              class="absolute right-4 rounded-full p-1 transition focus:bg-bgr-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-thm-hover focus:border-thm-hover"
              @click="close"
            >
              <WebccIcon name="site/x" class="h-6 w-6 text-txt-weak" />
            </button>
          </header>

          <section class="flex-1 overflow-y-auto">
            <RedesignFilter v-model="innerModel" class="w-full" />
          </section>

          <footer
            class="sticky bottom-0 border-t bg-bgr p-6 w-full flex flex-row flex-wrap justify-between"
          >
            <button
              class="text-left underline font-semibold flex gap-1 items-center"
              @click.stop="removeAll"
            >
              {{ $t(`${trPrefixCommon}removeAllFilters`) }}
            </button>

            <WebccButton
              variant="theme"
              class="!py-2.5 !px-3 !text-base"
              @click="apply"
            >
              {{ $t(`${trPrefixCommon}viewPlaces`, total) }}
            </WebccButton>
          </footer>
        </HeadlessDialogPanel>
      </div>
    </div>
  </HeadlessDialog>
</template>

<script setup lang="ts">
import { cloneDeep } from 'lodash-es'

const trPrefixCommon = 'www.common.'

const model = defineModel<SearchState>({ required: true })

defineProps<{ open: boolean }>()

const emits = defineEmits<{ close: [] }>()

const innerModel = ref(cloneDeep(model.value))

const screen = useScreen()
const { removeAll } = useSelectedSearchStateValues(innerModel)
const searchResults = useSearchResults(toReactive(innerModel))

const total = computed(() => searchResults.total)

function close() {
  emits('close')
}

function apply() {
  model.value = cloneDeep(innerModel.value)
  close()
}
</script>

<style scoped></style>
